'use strict';

var Radio = require('backbone.radio');
var moment = require('moment-timezone');
var maps = require('../../utilities/maps').default;
var Marionette = require('backbone.marionette');
var polyglot = require('../../utilities/polyglot').default;

var Request = require('../../models/request').default;
var Tracker = require('../../../analytics/events').default;
var Preference = require('../../models/preference').default;
var StaffCollection = require('../../collections/staff').default;
var AdvancedWaitListView = require('../requests/advanced-form').default;
var LanguageCollection = require('../../collections/languages').default;
var htmlHelpers = require('../../../../../../public/js/packages/coconut-calendar/helpers/EscapeHtml').default;

export default Marionette.View.extend({

  className: 'request-details',
  template: require('./templates/request-details.hbs'),
  ui: {
    details: '.request-confirm-details',
    cancelComplete: '.cancel-complete',
    rightColumn: '.request-details-right-column',
    map: '.request-details-map',
    editButton: '.request-edit-button',
    removeLink: '.request-details-remove',
  },
  events: {
    'click @ui.editButton': 'onClickEditButton',
    'click @ui.removeLink': 'onClickRemoveLink',
  },

  initialize: function (options) {
    this.model = options.request;
    this.staff = new StaffCollection(window.REQUEST_USERS);
    this.languages = new LanguageCollection(window.LANGUAGES);
    this.showMessage = options.showMessage;
    this.attempt = options.attempt;
    this.listenTo(Radio.channel('complete-request-cancel'), 'complete:cancel', this.onCancelComplete);
  },

  serializeData: function () {
    var json = this.model.toJSON();

    json.staffPickerDisabled = this.model.isStaffPickerHidden();
    json.showMessage = this.showMessage;
    json.atLocation = this.getAtLocation(json.location.name);
    json.isVirtual = json.location.virtual;
    json.timePreferences = this.getTimePreferences();
    json.staffSelection = json.user ? json.user.full_name : polyglot.t('pages.waitlist_confirmation.no_staff');
    json.bookLink = this.getBookingLink();
    json.notInterested = this.attempt == Request.STATUSES.BOOKING_NOT_INTERESTED;
    json.failedToBook = this.attempt == Request.STATUSES.BOOKING_FAILED;

    return json;
  },

  onDomRefresh: function () {
    var location = this.model.get('location');

    if (location && !location.virtual) {
      this.renderMap();
    }
    this.ui.cancelComplete.hide();
  },

  getBookingLink: function () {
    return window.location.pathname + '?lang=' + new LanguageCollection(window.LANGUAGES).getCurrent();
  },

  /**
   * Set page focus.
   */
  focus: function () {
    this.$el.find('.request-confirm-details .alert-info i').focus();
  },

  /**
   * Renders our interactable map.
   */
  renderMap: function () {
    var location = this.model.get('location');
    var latitude = parseFloat(location.latitude);
    var longitude = parseFloat(location.longitude);

    var map = new maps.Map(this.ui.map[0], {
      center: { lat: latitude, lng: longitude },
      zoom: 18,
      streetViewControl: false,
      mapTypeControl: false,
    });

    new maps.Marker({
      position: {
        lat: latitude,
        lng: longitude,
      },
      map: map,
      title: location.name,
    });
  },

  /**
   * Formats the location's name.
   * @param name
   * @returns {string}
   */
  getAtLocation: function (name) {
    return '<strong>' + htmlHelpers.escapeHtml(name) + '</strong>';
  },

  /**
   * Triggers the edit modal to appear.
   *
   * @param evt
   */
  onClickEditButton: function (evt) {
    evt.preventDefault();
    Tracker.trackView('waitlist-edit-modal');
    Radio.channel('modal').trigger('show', new AdvancedWaitListView({
      model: this.model,
      staff: this.staff,
    }));
  },

  /**
   * Triggers the remove from wait list toast to appear.
   *
   * @param evt
   */
  onClickRemoveLink: function (evt) {
    evt.preventDefault();
    Radio.channel('waitlist_confirmation').trigger('show', {
      parent: this.parent,
      model: this.model,
    });
  },

  getTimePreferences: function () {
    var preferences = this.model.get('preferences');
    var type = preferences.length ? preferences.first().get('type') : null;
    if (type === Preference.TYPES.NEXT_AVAILABLE) {
      return {
        title: polyglot.t('pages.waitlist_confirmation.next_available'),
        preferences: [],
      };
    }

    var values = preferences.map((preference) => {
      var day = Preference.DAYS[preference.get('day')];
      var start = moment(preference.get('start_time'), 'HH:mm:ss').format('LT');
      var end = moment(preference.get('end_time'), 'HH:mm:ss').format('LT');

      return {
        day,
        time: `${start} - ${end}`,
      };
    });

    return {
      title: polyglot.t('pages.waitlist_confirmation.certain_days'),
      timezone: `(${polyglot.t('pages.waitlist_confirmation.preferences_timezone')} ${this.model.getTimezoneAbbr()})`,
      preferences: values,
    };
  },

  /**
   * Removes appointment from the collection, removes visual elements re: the
   * appointment + cancel toast, and displays the cancel complete UI.
   */
  onCancelComplete: function () {
    Radio.channel('cancel-toast').trigger('hide');
    this.ui.details.hide();
    this.ui.cancelComplete.show();
  },
});
